module.exports = __webpack_public_path__ + "img/icon-6.000167c3.png";